<template>

    <div class="list1">
        <div class="row block1_1">
            <a :href="`${detailsLinkPage}?chnid=${topData.chnid}&leafid=${topData.leafid
                }&&docid=${topData.code ? topData.code.substring(4, topData.code.length) : ''}&uid=${topData.uid}&version=integrated`"
                target="_blank">
                {{ topData.title }}
            </a>
        </div>
        <div class="row block1_2">
            <!-- <div class="lbTitle">高层声音：</div> -->
            <!-- <div>{{marqueeList}}</div> -->
            <vue-marquee style="height: 23px; width: 95%; line-height: 21px" :showProgress="false"
                v-if="marqueeList.length > 0">
                <vue-marquee-slide v-for="(i, index) in marqueeList" :key="index">
                    <span class="crilce"></span>
                    <a class="marqueeTitle" :href="`${detailsLinkPage}?chnid=${i.chnid}&leafid=${i.leafid
                        }&docid=${i.code.substring(4, i.code.length)}&uid=${i.uid
                        }&version=integrated`" style="line-height: 21px;" target="_blank">{{ i.title }}</a>
                </vue-marquee-slide>
            </vue-marquee>
            <a class="titletopic" target="_blank" href="http://www.drcnet.com.cn/specialTopic?uid=A10902">
                <img src="./images/more.png" style="
						height: 21px;
						cursor: pointer;
						margin-left: 10px;
						padding-top: 1px;
						padding-right: 2px;
					" alt="" />
            </a>
        </div>
    </div>
</template>
<script>

// import { getHomeList } from '../../../../../api/home';
// import VueMarquee from 'vue-marquee-component';

import axios from 'axios';
export default {
    name: '',

    mixins: [],
    props: {},
    data() {
        return {
            hightTitle: '', //高层声音标题
            marqueeList: [],
            everyDay: [], //每日
            expertData: [], //专家
            activeIndex: 0, //当前在哪个index下
            hottopicList: [],
            onePicture: [],
            onePictureindex: 0,
            isMoblie: false,
            DJZTList: [],
            specialTopicContent: {}, //特殊单独专题（根据chnid查询呢）
            detailsLinkPage: 'https://d.drcnet.com.cn/',
            topData: [], //子专题数据
        };
    },
    computed: {},
    created() { this.getDatasTop(); this.getDatasSub(); },
    mounted() {

        this.setFocus(0);
        setInterval(() => {
            if (this.activeIndex <= 3) {
                this.setFocus(this.activeIndex + 1);
            } else {
                this.setFocus(0);
            }
            // this.setFocus(activeIndex+1);
        }, 3000);
    },
    methods: {
        // async getDatas() {
        //     try {
        //         const response = await axios.get('http://www.drcnet.com.cn/reportapi/CommonController/common/getDocListByUid', {
        //             params: {
        //                 uid: 'A109',
        //                 curpage: 1,
        //                 pagesize: 10,
        //             },
        //         });
        //         if (response.data?.data?.doc) {
        //             const docList = response.data.data.doc;
        //             this.hightTitle = docList[0] || null;
        //             this.marqueeList = docList.slice(1, 10);
        //         }
        //     } catch (err) {
        //         console.error('API 请求失败:', err);
        //     }
        // },
        async getDatasTop() {
            try {
                // const response = await axios.get('https://www.drcnet.com.cn/reportapi/CommonController/common/getDocListByUid', {
                const response = await axios.get(window.baseurl+'reportapi/CommonController/common/getDocListByUid', {
                    params: {
                        uid: 'A10901',
                        curpage: 1,
                        pagesize: 1,
                    },
                });

                if (response.data?.data?.doc) {
                    const docList = response.data.data.doc[0];
                    this.topData = docList || null;

                }
            } catch (err) {
                console.error('API 请求失败:', err);
            }
        },
        async getDatasSub() {
            try {
                // const response = await axios.get('https://www.drcnet.com.cn/reportapi/CommonController/common/getDocListByUid', {
                const response = await axios.get(window.baseurl+'reportapi/CommonController/common/getDocListByUid', {
                    params: {
                        uid: 'A10902',
                        curpage: 1,
                        pagesize: 10,
                    },
                });

                if (response.data?.data?.doc) {
                    const docList = response.data.data.doc;
                    this.hightTitle = docList[0] || null;
                    this.marqueeList = docList.slice(1, 10);
                }
            } catch (err) {
                console.error('API 请求失败:', err);
            }
        },
        //设置当前显示那个专家
        setFocus(index) {
            this.activeIndex = index;
        },
        setOnpirce(index) {
            this.onePictureindex = index;
        },
    },
};
</script>
<style lang="scss" scoped>

.list1 {
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 24px;

    .shuangtan_img_info_item {
        width: 208px !important;
    }

    .block1_1 {
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: normal;
        font-size: 38px;
        line-height: 40px;
        color: #ff0000;
        width: 100%;
        margin: 17px auto;

        // white-space: nowrap;
        // overflow: hidden;
        a {
            color: #ff0000;
            word-wrap: break-word;
            word-break: normal;
        }
    }

    .block1_2 {
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 15px;
        color: #666666;
        margin-bottom: 19px;
        white-space: nowrap;
        overflow: hidden;
        display: flex;

        .lbTitle {
            display: inline-block;
            color: #1a1a1a;
        }

        .crilce {
            display: inline-block;
            margin-right: 5px;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: #666666;
            vertical-align: middle;
        }

        .marqueeTitle {
            color: #666666;
            margin-right: 18px;
        }
    }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 769px) {
    .docU {
        height: 100% !important;

        padding: 30px 10px !important;
    }

    .wxsjk {
        ::v-deep .titletopic {
            background-position: -399px 0px !important;
        }
    }

    .docUUp {
        flex-direction: column;

        .docUUpContent {
            width: 100% !important;
        }

        .every {
            .everyTitle {
                white-space: inherit !important;
                padding-bottom: 10px !important;
                width: 70% !important;
            }

            .everyTime {
                width: 26% !important;
            }
        }

        .focusPic {
            .img_box {}

            .zj_text {
                padding-left: 15px !important;
                max-width: 70%;
            }

            .oncss li {
                width: 25px !important;

                a {
                    width: 12px !important;
                    height: 12px !important;
                }
            }
        }
    }
}
</style>
